/** PURE_IMPORTS_START ._BoundCallbackObservable PURE_IMPORTS_END */
import { BoundCallbackObservable } from './BoundCallbackObservable';
export var bindCallback = BoundCallbackObservable.create;
//# sourceMappingURL=bindCallback.js.map 



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/observable/bindCallback.js
// module id = ./node_modules/rxjs/_esm5/observable/bindCallback.js
// module chunks = vendor